import { gql } from '@apollo/client';

import { JourneyMetadata } from './types';

export const USE_JOURNEY_HOOK_QUERY = gql`
  query JourneyQuery($id: Long!) {
    draftJourney: workflow(id: $id, workflowType: Draft) {
      id
      name
    }
    publishedJourney: workflow(id: $id, workflowType: Published) {
      id
      name
    }
  }
`;

export const USE_JOURNEYS_HOOK_QUERY = gql`
  query JourneysQuery($search: String!, $pagination: Pagination!, $sort: Sort!) {
    journeys: workflowFolder(
      filterInfo: { workflowType: [Draft, Published] }
      content: [ContentItem]
      recursive: true
      search: $search
      pagination: $pagination
      sort: $sort
    ) {
      results: content {
        ... on Workflow {
          id
          name
        }
        __typename
      }
    }
  }
`;

export const JOURNEY_METADATA_FRAGMENT = gql`
  fragment JourneyMetadata on Workflow {
    id
    name
  }
`;

export const DEFAULT_JOURNEYS: JourneyMetadata[] = [];
